import { MentionNodeSpec, MENTION_KEY } from '@techchange/pm-specs';

import MentionDropdown from './components/MentionDropdown';
import UserTooltip from './components/UserTooltip';
import mentionTrigger from './plugins/mentionTrigger';
import mentionViewPlugin from './plugins/mentionView';

const mention = {

	nodes() {

		return {
			[MENTION_KEY]: MentionNodeSpec,
		};

	},

	plugins(options) {

		return [
			mentionTrigger(),
			mentionViewPlugin(
				options.mentionUsers, options.scope, options.scopeId, options.onMentionClick
			),
		];

	},

	tooltips() {

		return [
			{
				Tooltip: MentionDropdown,
				key: () => 'MentionDropdown',
			},
			{
				Tooltip: UserTooltip,
				key: () => 'UserTooltip',
				showOnReadOnly: true,
			}
		];

	},

};

export default mention;
